import { ref } from 'vue';
import { useHttp, useToasts } from '@/composables';
import { HttpStatusCode } from 'axios';

export function useEntityArchiver(entityName, loadEntities) {
  const archiving = ref(false);
  const entityToArchive = ref(null);
  const toasts = useToasts();

  const archiveEntity = async () => {
    if (entityToArchive.value) {

      archiving.value = true;
      const response = await useHttp().post(`/${entityName}/${entityToArchive.value.id}/archive`);

      // Capitalizes the first letter and removes the trailing s
      let singularName = entityName;
      if (singularName.endsWith('ies')) {
        singularName = singularName.slice(0, -3) + 'y';
      } else if (singularName.endsWith('s')) {
        singularName = singularName.slice(0, -1);
      }

      const captilizedName = singularName.charAt(0).toUpperCase() + singularName.slice(1);

      if (response.statusCode === HttpStatusCode.Ok) {
        toasts.success(`${captilizedName} successfully archived`);
        entityToArchive.value = null;

        loadEntities();
      } else {
        toasts.error(`Could not archive ${captilizedName}`);
      }

      archiving.value = false;
    }
  };

  return {
    archiving,
    entityToArchive,
    archiveEntity,
  };
}
